import { AuthContext, AuthContextType } from "modules/auth/src/auth-context"
import { useContext } from "react"

export function useAuth (): AuthContextType {
    return useContext( AuthContext )
}
